import React from 'react';
import PropTypes from 'prop-types';
import './Text.css';

interface TextProps extends React.HTMLAttributes<HTMLElement> {
    type?: 'default' | 'secondary' | 'success' | 'warn' | 'danger' | 'disabled';
    mark?: boolean;
    code?: boolean;
    underline?: boolean;
    delete?: boolean;
    strong?: boolean;
    italic?: boolean;
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
}

/**
 * A simple text component.
 * 
 * ## _
 * ### Arguments
 * @param {string} type - One of 'default', 'secondary', 'success', 'warn', 'danger', or 'disabled'. Applies styling based on the type.
 * @param {boolean} mark - Flag to set the text to be highlighted.
 * @param {boolean} code - Flag to set the text to be styled like code.
 * @param {boolean} underline - Flag to set the text to be underlined.
 * @param {boolean} delete - Flag to set the text to be struck through.
 * @param {boolean} strong - Flag to set the text to be bolded.
 * @param {boolean} italic - Flag to set the text to be italics.
 * @param {React.ReactNode} children - The contents inside the button.
 * @param {string} className - CSS classes to apply to the button.
 */
class Text extends React.Component<TextProps> {
    static propTypes = {
        type: PropTypes.oneOf(['default', 'secondary', 'success', 'warn', 'danger', 'disabled']),
        mark: PropTypes.bool,
        code: PropTypes.bool,
        underline: PropTypes.bool,
        delete: PropTypes.bool,
        strong: PropTypes.bool,
        italic: PropTypes.bool,
        children: PropTypes.node.isRequired,
        className: PropTypes.node,
    }

    static defaultProps = {
        type: 'default',
        className: "",
        mark: false,
        code: false,
        underline: false,
        delete: false,
        strong: false,
        italic: false,
    }

    render() {
        const { type, mark, code, underline, delete: del, strong, italic, children, className, ...rest } = this.props;

        let classes = `${className} text text--${type}`;

        if (mark) classes += ' text--mark';
        if (code) classes += ' text--code';
        if (underline) classes += ' text--underline';
        if (del) classes += ' text--delete';
        if (strong) classes += ' text--strong';
        if (italic) classes += ' text--italic';

        return (
            <span className={classes} {...rest}>
                {children}
            </span>
        );
    }
}

export default Text;